import { useAppSelector } from 'hooks'
import { useMemo } from 'react'
import { getStatusSelector } from 'redux/store/slices/statusSlice'
import { getNotificationsSelector, getThirdPartyNotificationsSelector } from 'redux/store/slices/wsSlice'
import { FLOW_STEPS } from 'share/types'
import { getWsStepStatus } from 'utils'

const useThirdPartyPledgerStatus = () => {
  const { AWAITING_THIRD_PARTY_PROPERTY_CHOICE } = useAppSelector(getNotificationsSelector)
  const { flow_status: pledgerFlowStatus } = useAppSelector(getThirdPartyNotificationsSelector)
  const { current_step } = useAppSelector(getStatusSelector)

  const isPledgerChosePropertyByWS = useMemo(
    () => getWsStepStatus(AWAITING_THIRD_PARTY_PROPERTY_CHOICE) === 'DONE',
    [AWAITING_THIRD_PARTY_PROPERTY_CHOICE]
  )

  const isPledgerChosePropertyByStatus = useMemo(() => {
    if (!current_step) return false
    const { step, status } = current_step
    if (step === FLOW_STEPS.AWAITING_THIRD_PARTY_PROPERTY_CHOICE && status === 'DONE') return true
    return false
  }, [current_step])

  const isPledgerConfirmationFlowDoneByStatus = useMemo(() => {
    if (!current_step) return false
    const { flow_type, flow_status } = current_step
    if (flow_type === 'CONFIRMATION_THIRD_PARTY_PLEDGE' && flow_status === 'DONE') return true
    return false
  }, [current_step])

  const isPledgerConfirmationFlowDoneByWS = useMemo(() => {
    if (pledgerFlowStatus === 'DONE') return true
    return false
  }, [pledgerFlowStatus])

  const isPledgerConfirmationFlowDone = useMemo(() => {
    if (isPledgerConfirmationFlowDoneByStatus || isPledgerConfirmationFlowDoneByWS) return true
    if (isPledgerChosePropertyByWS || isPledgerChosePropertyByStatus) return true
    return false
  }, [
    isPledgerChosePropertyByStatus,
    isPledgerChosePropertyByWS,
    isPledgerConfirmationFlowDoneByStatus,
    isPledgerConfirmationFlowDoneByWS
  ])

  return {
    isPledgerChosePropertyByWS,
    isPledgerChosePropertyByStatus,
    isPledgerConfirmationFlowDoneByStatus,
    isPledgerConfirmationFlowDoneByWS,
    isPledgerConfirmationFlowDone
  }
}

export { useThirdPartyPledgerStatus }
